import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationBarComponent } from './notification-bar.component';
import { ButtonModule } from '../button';
import { AvatarModule } from '../avatar';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [NotificationBarComponent],
  imports: [CommonModule, ButtonModule, AvatarModule, MatIconModule],
  exports: [NotificationBarComponent],
})
export class NotificationBarModule {}
